import BaseAPI from './BaseAPI';
import Alarm from '../models/Alarm';
import {getLocaleFromLang} from "../functions";


export class AlarmAPI extends BaseAPI {

	async setInProgress(alarmId) {
		return this.request(`/-/alarm/inProgress`, 'POST', {alarmId});
	}
	async saveExpirationTime(expiration) {
		return this.request(`/-/account/alertExpiration`, 'PUT', {expiration});
	}
	async saveAttendanceMinimums(minimums) {
		return this.request(`/-/account/attendanceMinimums`, 'PUT', minimums);
	}
	async getSafetyRegions() {
		return this.request(`/-/safetyRegions`);
	}
	async loadSnapshot(alarmId) {
		return this.request(`/-/alarm/${alarmId}/snapshot`);
	}

	async getClosedBy(alarm: Alarm) {
		return this.request(`/-/alarm/${alarm.id}/closedBy`);
	}

	async shareAlarm(alarm: Alarm, recipients: string, language: string) {
		return this.request('/-/alarm/share', 'POST', { alarm: alarm.toJS(), recipients, language });
	}

	closeAlarm(alarm: Alarm, blackbox) : Promise {
		return this.request('/-/alarm', 'PUT', {
			id: alarm.id,
			notes: alarm.get('notes'),
			done: true,
			blackbox
		});
	}

	openAlarm(alarm: Alarm) {
		this.request('/-/alarm', 'PUT', {
			id: alarm.get('id'),
			done: false
		});
	}

	cancelAlarm(alarm: Alarm) {
		this.request('/-/alarm', 'DELETE', {
			id: alarm.get('id')
		});
	}

	async getAlarmByToken(token: string) {
		const json = await this.request(`/-/alarm/token/${token}`, 'GET');
		return new Alarm(json);
	}

	async getWizard(alarmId, lang) {
		lang = getLocaleFromLang(lang);
		try {
			return await this.request(`/-/alarm/${alarmId}/wizard/${lang}`, 'GET');
		} catch (e) {}
	}
}
